// extracted by mini-css-extract-plugin
export default {"content":"LogoPage_content__QJKnZ","logo":"LogoPage_logo__K4y6+","heading":"LogoPage_heading__fYOtt","links":"LogoPage_links__08ai+","downloadAll":"LogoPage_downloadAll__1MqDD"};